<template>
    <div>
        <el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
            <el-form :inline="true">
                <el-form-item>
                    <el-input v-model="Mobile" placeholder="请输入用户手机号" prefix-icon="el-icon-search" size="small"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="Find" icon="el-icon-search">查询</el-button>
                </el-form-item>
                <el-form-item style="float: right;">
                    <el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <el-table :data="List" border v-loading="isloading" style="width: 100%" :max-height="maxHeight">
            <el-table-column prop="nickname" label="昵称"></el-table-column>
            <el-table-column prop="gender" label="性别">
                <template slot-scope="scope">
                    <span v-if="scope.row.gender == 0">未知</span>
                    <span v-if="scope.row.gender == 1">女</span>
                    <span v-if="scope.row.gender == 2">男</span>
                </template>
            </el-table-column>
            <el-table-column prop="mobile" label="手机号"></el-table-column>
            <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.opening_game == 0" size="mini" type="primary" @click="OpenGame(scope.row.id)">开通游戏</el-button>
                    <el-button v-if="scope.row.opening_game == 1" size="mini" type="success" @click="CloseGame(scope.row.id)">已开通</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-col :span="24" class="toolbar downtool">
            <!--<el-button v-if="Limits.warehoused_index" type="primary" size="small" @click="ShowIn">显示已入库设备</el-button>-->
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;"></el-pagination>
        </el-col>
    </div>
</template>

<script>
    import {GetMobileAppUserList, OpenOrCloseGameOfMobileAppUser} from "../../api/api";

    export default {
        data(){
            return {
                token:"",
                Limits:"",
                Pagesize:20,
                Curpage:1,
                List:[],
                maxHeight:600,
                isloading:false,
                total:1
            }
        },
        methods:{
            Find(){
                if(this.Mobile){
                    var that = this;
                    var q = "[{\"AND\":{\"mobile\":\"~"+this.Mobile+"\"}}]";
                    // console.log(q);
                    GetMobileAppUserList({page:this.Curpage,token:this.token,q:q}).then(res=>{
                        // console.log("lbf1",res);
                        that.List = res.data.items;
                        that.total = res.data.meta.totalCount;
                        that.isloading = false;
                    }).catch(err=>{
                        console.log(err);
                        that.isloading = false;
                    });
                }
            },
            Refresh(){
                var that = this;
                this.Mobile = "";
                this.Curpage = 1;
                GetMobileAppUserList({page:this.Curpage,token:this.token}).then(res=>{
                    // console.log("lbf1",res);
                    that.List = res.data.items;
                    that.total = res.data.meta.totalCount;
                    that.isloading = false;
                }).catch(err=>{
                    console.log(err);
                    that.isloading = false;
                });
            },
            handleCurrentChange(val){
                var that = this;
                this.Curpage = val;
                GetMobileAppUserList({page:this.Curpage,token:this.token,sort:"id"}).then(res=>{
                    // console.log("lbf1",res);
                    that.List = res.data.items;
                    that.total = res.data.meta.totalCount;
                    that.isloading = false;
                }).catch(err=>{
                    console.log(err);
                    that.isloading = false;
                });
            },
            OpenGame(userid){
                var that = this;
                // console.log("lbf-op",userid);
                let param = {
                    permission:1
                };
                OpenOrCloseGameOfMobileAppUser(that.token,userid,param).then(res=>{
                    // console.log("OpenGame-res:",res);
                    this.GetList(GetMobileAppUserList,{page:this.Curpage,token:this.token,sort:"-id"});
                }).catch(err=>{
                    // console.log("OpenGame-err:",err);
                    this.$message.error('对不起，操作失败。');
                });
            },
            CloseGame(userid){
                var that = this;
                // console.log("lbf-cl",userid);
                let param = {
                    permission:0
                };
                OpenOrCloseGameOfMobileAppUser(that.token,userid,param).then(res=>{
                    // console.log("OpenGame-res:",res);
                    this.GetList(GetMobileAppUserList,{page:this.Curpage,token:this.token,sort:"-id"});
                }).catch(err=>{
                    // console.log("OpenGame-err:",err);
                    this.$message.error('对不起，操作失败。');
                });
            },
            GetList(){
                var that = this
                let param = {
                    token:that.token,
                    // q:'[{"AND":{"mobile":"~132"}}]',
                    perPage:that.Pagesize,
                    page:that.Curpage
                }
                GetMobileAppUserList(param).then(res=>{
                    // console.log("lbf1",res);
                    that.List = res.data.items;
                    that.total = res.data.meta.totalCount;
                    that.isloading = false;
                }).catch(err=>{
                    console.log(err);
                    that.isloading = false;
                });
            }
        },
        created() {
            this.token = sessionStorage.getItem("BBRtoken");
            this.Limits = JSON.parse(sessionStorage.getItem("limits"));
            this.isloading = true;
            this.GetList();
        },
        mounted(){
            this.$nextTick(function(){
                this.Gethigh()
            })
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// MobileAppUserManagement.vue?5d088114